
export const pricing = {
  hero: {
    title: 'Precios adaptados a tu negocio',
    subtitle: 'Cada negocio es único. Nuestros precios se definen según tus necesidades específicas, volumen de citas y facturación. Solicita una consulta gratuita para recibir una propuesta personalizada.'
  },
  packages: {
    title: 'Paquetes prefijados',
    items: [
      {
        label: 'Paquete',
        name: 'Starter',
        features: [
          'Chatbot en WhatsApp y 1 red social',
          'Gestión de agenda básica',
          'Recordatorios automáticos',
          'Soporte por email',
          'Hasta 200 citas/mes'
        ],
        price: 'A consultar',
        note: 'Según necesidades y facturación'
      },
      {
        label: 'Paquete',
        name: 'Professional',
        features: [
          'Chatbot en WhatsApp y todas las redes',
          'Sistema completo de gestión de agenda',
          'Recordatorios multicanal',
          'Página web con reservas integradas',
          'Soporte prioritario',
          'Hasta 500 citas/mes'
        ],
        price: 'A consultar',
        note: 'Según necesidades y facturación'
      },
      {
        label: 'Paquete',
        name: 'Enterprise',
        features: [
          'Todo lo de Professional',
          'Múltiples ubicaciones y profesionales',
          'Integraciones personalizadas',
          'Consultoría estratégica incluida',
          'Soporte 24/7',
          'Citas ilimitadas'
        ],
        price: 'A consultar',
        note: 'Según necesidades y facturación'
      }
    ]
  },
  custom: {
    title: 'Soluciones a medida',
    description: 'Si ningún paquete se ajusta perfectamente a tu negocio, diseñamos una solución completamente personalizada. Selecciona solo los servicios que necesitas y escala cuando lo requieras.',
    price: 'A consultar',
    note: 'Presupuesto personalizado según tus necesidades específicas'
  }
};
